import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doRequestMe } from "../../../app/state/actions";
import { doLoginRequest, doRegisterRequest } from "../../state/actions";
import RegisterForm from "../../components/registerForm";
import LoginForm from "../../components/loginForm";
import FooterBuy from "../../components/footerBuy";
import FooterRegister from "../../components/registerFooter";
import FooterLogin from "../../components/loginFooter";
import "./buy.scss";

class Identify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      register: true
    };

    this.registerRef = React.createRef();
    this.loginRef = React.createRef();

    this.goToLogin = this.goToLogin.bind(this);
    this.goToRegister = this.goToRegister.bind(this);
    this.onRegister = this.onRegister.bind(this);
    this.onLogin = this.onLogin.bind(this);
  }

  goToLogin() {
    this.setState({
      register: false
    });
  }

  goToRegister() {
    this.setState({
      register: true
    });
  }

  onLogin(formValues) {
    return this.props
      .doLoginRequest(formValues)
      .then(this.props.doRequestMe)
      .then(() => {
        this.props.history.replace("/assine/pagamento");
      });
  }

  onRegister(formValues) {
    const { history, doRequestMe, doLoginRequest, doRegisterRequest } = this.props;
    doRegisterRequest(formValues)
      .then(() => doLoginRequest(formValues))
      .then(doRequestMe)
      .then(() => history.replace("/assine/pagamento"))
      .catch(e => {
        if (e === "422" || e === 422) {
          this.registerRef.current.setError("email", "E-mail já cadastrado");
        }
      });
  }

  register() {
    const { ui } = this.props;

    return (
      <Fragment>
        <RegisterForm
          className="is-flux"
          ref={this.registerRef}
          onRegister={this.onRegister}
          isRegistering={ui.isRegistering || ui.isLogging}
        />
        <FooterRegister onDoLogin={this.goToLogin} />
      </Fragment>
    );
  }

  login() {
    const { ui } = this.props;

    return (
      <Fragment>
        <LoginForm className="is-flux" ref={this.loginRef} onLogin={this.onLogin} isLogging={ui.isLogging} />
        <FooterLogin onDoRegister={this.goToRegister} />
      </Fragment>
    );
  }

  onNext() {
    const { register } = this.state;

    if (register) {
      this.registerRef.current.doRegister();
    } else {
      this.loginRef.current.doLogin();
    }
  }

  onBack() {}

  render() {
    const { ui } = this.props;
    const { register } = this.state;
    return (
      <Fragment>
        <section className="content-buy">{register ? this.register() : this.login()}</section>
        <FooterBuy
          disabled={true}
          ref={this.footerRef}
          isNexting={ui.isRegistering || ui.isLogging}
          onNext={() => this.onNext()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state.account
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      doLoginRequest,
      doRequestMe,
      doRegisterRequest
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Identify));

Routered.displayName = "Identify";

export default Routered;
